module.exports = __webpack_public_path__ + "static/wikiBackgroundNew-c012ca4999ed85618845eabd09677cc9.jpg";